import ActivityLogs from './ActivityLogs';

export default ActivityLogs;
